import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';

import { HorizontalTabs, HTab } from '../../components/HorizontalTabs';
import Page from '../../components/Page';
import { getTabSelectOptions } from '../../constants/tabMenuTypes';
import { setCurrentPage } from '../../redux/modules/app';
import { selectCompanyId } from '../../redux/modules/company';
import { globalRequirementTemplateBuilder } from '../../redux/reducer';

import TemplatesPageHeader from './components/TemplatesPageHeader';

const TemplatesListPage = () => {
  const dispatch = useDispatch();
  const companyId = useSelector(selectCompanyId);

  useEffect(() => {
    dispatch(setCurrentPage('templates'));

    if (companyId) {
      dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders());
    }
  }, [companyId, dispatch]);

  useEffect(() => () => dispatch(globalRequirementTemplateBuilder.resetCurrentFolder()), [dispatch]);

  const horizontalTabs = getTabSelectOptions('templateTabs');

  return (
    <Page fixedHeight>
      <Box height="100%">
        <TemplatesPageHeader />
        <HorizontalTabs minHeight="710px" paddingLeft="400px" tabGroupWidth="850px">
          {horizontalTabs.map(option => (
            <HTab {...option} key={option.tabId} />
          ))}
        </HorizontalTabs>
      </Box>
    </Page>
  );
};

export default TemplatesListPage;
